import { render } from "./TreeDetails.vue?vue&type=template&id=59d0c8c8"
import script from "./TreeDetails.vue?vue&type=script&lang=js"
export * from "./TreeDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__